import {
  OPEN_DISCARD_DIALOG,
  CLOSE_DISCARD_DIALOG
} from "redux/constants/flowDesigner";

export const openDiscardDialog = () => ({
  type: OPEN_DISCARD_DIALOG
});
export const closeDiscardDialog = () => ({
  type: CLOSE_DISCARD_DIALOG
});